import { Button } from "@material-tailwind/react";
import React from "react";
import { useNavigate } from "react-router-dom"; // If using React Router
import { URLS } from "../../router-x/routes";

function NotFound() {
    const navigate = useNavigate(); // React Router navigation hook

    return (
        <div className="flex flex-col items-center justify-center min-h-[90vh] text-gray-800">
            <h1 className="text-6xl font-bold mb-4">404</h1>
            <h2 className="text-2xl font-semibold mb-4">Page Not Found</h2>
            <p className="text-gray-600 mb-8">
                The page you are looking for doesn't exist or has been moved.
            </p>
            <Button
                onClick={() => navigate(URLS.ADMIN.ROOT)} // Redirect to homepage
                variant="contained"
                disableElevation
                className="rounded-full"
            >
                Go Home
            </Button>
        </div>
    );
}

export default NotFound;
